import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Acesso} from 'src/app/core/acesso';
import {ControlContainer, NgForm} from '@angular/forms';
import {ToastService} from 'src/app/services/toast/toast.service';
import * as _ from "lodash";
import {MetaAcaoExecutada} from "../../../core/meta-acao-executada";
import {MetaAcao} from "../../../core/meta-acao";
import {MetaObjetivo} from "../../../core/metaObjetivo";

@Component({
    selector: 'formulario-metas',
    templateUrl: './formulario-metas.component.html',
    styleUrls: ['./formulario-metas.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FormularioMetasComponent implements OnInit {

    @Input() idAtividade: number;
    @Input() metas: MetaAcaoExecutada[];
    @Input() meta: MetaAcaoExecutada;
    @Input() index: number;
    @Input() perfilAcesso: Acesso;
    @Input() desabilitarCampos: boolean;

    idRandomico = Math.random();

    constructor(private drc: ChangeDetectorRef,
                private toastService: ToastService) {
    }

    ngOnInit(): void {
        if(this.meta?.metaAcao?.metaObjetivo)
        this.meta.metaAcao.metaObjetivo.descricao = this.meta.metaAcao.metaObjetivo.codigo + ' - ' + this.meta.metaAcao.metaObjetivo.descricao;
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }

    deletar() {
        this.metas.splice(this.index, 1);
        this.toastService.showSucesso("Meta removida com sucesso.")
    }

    onValorChangeMeta(registro: any) {
        if (registro && registro.id) {
            const metaJaCadastrado = _.find(this.metas, (metasAcao: MetaAcaoExecutada) => metasAcao.metaAcao?.metaObjetivo?.id === registro.id);
            if (_.isEmpty(metaJaCadastrado)) {
                this.meta.metaAcao = new MetaAcao();
                this.meta.metaAcao.metaObjetivo = new MetaObjetivo();
                this.meta.metaAcao.metaObjetivo.id = registro.id;
                this.meta.metaAcao.metaObjetivo.descricao = registro.descricao;
            } else {
                this.toastService.showAlerta("Meta já adicionada.")
                this.metas.splice(this.index, 1);
                this.meta = new MetaAcaoExecutada();
                this.metas.splice(this.index, 0, this.meta);
            }
        }
    }

}
